import { RealmPolicies } from './iam-policies-api.service';

export interface PolicyField {
  key: keyof RealmPolicies & string;
  label: string;
  type: 'number' | 'checkbox';
  min?: number;
  max?: number;
}

export interface PolicySection {
  id: string;
  title: string;
  description: string;
  fields: PolicyField[];
}

export const POLICY_SECTIONS: PolicySection[] = [
  {
    id: 'sessions',
    title: 'Токены и сеансы',
    description:
      'Время задаётся в секундах. Изменение политики не продлевает уже завершённые сеансы.',
    fields: [
      {
        key: 'accessTokenLifespan',
        label: 'Срок access token',
        type: 'number',
        min: 1,
        max: 600,
      },
      {
        key: 'ssoSessionIdleTimeout',
        label: 'Допустимое бездействие SSO',
        type: 'number',
        min: 1,
      },
      {
        key: 'ssoSessionMaxLifespan',
        label: 'Предельный срок SSO',
        type: 'number',
        min: 1,
      },
    ],
  },
  {
    id: 'links',
    title: 'Ссылки и действия пользователя',
    description: 'Сроки в секундах. Истёкшая ссылка требует нового обращения.',
    fields: [
      {
        key: 'actionTokenGeneratedByUserLifespan',
        label: 'Ссылки восстановления и подтверждения пользователя',
        type: 'number',
        min: 1,
      },
      {
        key: 'actionTokenGeneratedByAdminLifespan',
        label: 'Действия, назначенные администратором',
        type: 'number',
        min: 1,
      },
    ],
  },
  {
    id: 'brute-force',
    title: 'Защита от перебора',
    description: 'Настройки применяет сервер при проверке учётных данных.',
    fields: [
      {
        key: 'bruteForceProtected',
        label: 'Включить защиту от перебора',
        type: 'checkbox',
      },
      {
        key: 'failureFactor',
        label: 'Количество неудачных попыток',
        type: 'number',
        min: 1,
      },
      {
        key: 'waitIncrementSeconds',
        label: 'Шаг блокировки, секунд',
        type: 'number',
        min: 1,
      },
      {
        key: 'maxFailureWaitSeconds',
        label: 'Максимум блокировки, секунд',
        type: 'number',
        min: 1,
      },
      {
        key: 'maxDeltaTimeSeconds',
        label: 'Период учёта ошибок, секунд',
        type: 'number',
        min: 1,
      },
    ],
  },
];
